import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,

} from "reactstrap";

// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter, Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Pagination from "../../components/Common/Pagination";
import Loader from "../../components/Common/Loader";

//actions
import { comprasList } from "../../store/compras/actions";

import { VerCompraModal } from "./components/VerCompraModal";
import { EditCompraModal } from "./components/EditCompraModal";

import { contactsFulllist } from "../../store/contacts/actions";

const Compras = (props) => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const groups = String(user.groups);



  useEffect(() => {
    dispatch(comprasList());
    dispatch(contactsFulllist());
  }, [dispatch]);

  const contact = useSelector((state) => state.Contacts.contacts) || [];
  const params = {
    count: props.compras.count,
    next: props.compras.next,
    previous: props.compras.previous,
    results: props.compras.results,
  };

  const [verCompras, setVerCompras] = useState(false);
  const [EditCompras, setEditCompras] = useState(false);

  const handleCloseModal = () => {
    setVerCompras(false);
  };
  const handleCloseModalEdit = () => {
    setEditCompras(false);
  };
  const [compraDetalle, setCompraDetalle] = useState(null);

  const handleVerCompras = (compra) => {
    setVerCompras(true);
    setCompraDetalle(compra);
  };

  const handleEditCompras = (compra) => {
    setEditCompras(true);
    setCompraDetalle(compra);
  };

  return (
    <React.Fragment>
      <VerCompraModal
        verCompras={verCompras}
        onCloseClick={handleCloseModal}
        compraDetalle={compraDetalle}
      ></VerCompraModal>

      <EditCompraModal
        EditCompras={EditCompras}
        onCloseClick={handleCloseModalEdit}
        compraDetalle={compraDetalle}
      ></EditCompraModal>
      <div className="page-content">
        <MetaTags>
          <title>Compras | Compras</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Compras"} breadcrumbItem={"Compras"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card className="col-lg-10 mx-auto  mt-3">
                <CardBody>
                  <Row>
                    <Col md={7}>
                      {groups.includes("SuperAdmin") ||
                      groups.includes("Supervisor") ||
                      groups.includes("Operador") ||
                      groups.includes("Crear y modificar Entidad Interna") ? (
                        <Link
                          className="btn btn-primary waves-effect waves-light"
                          to="/compras/add_compras"
                        >
                          AGREGAR{" "}
                          <span className="bx bx-user-plus fa-lg align-middle"></span>
                        </Link>
                      ) : null}
                    </Col>
                    <Col md={5}>
                      <Form
                        className="search-box"
                        //   onSubmit={onSubmit}
                      >
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            placeholder="Buscar"
                            //   value={search}
                            //   onChange={onChange}
                          />
                          <i className="bx bx-search-alt search-icon" />
                          <Button
                            color="primary"
                            //  onClick={resetSearch}
                          >
                            <span className=" bx bx-x fa-lg align-middle"></span>
                          </Button>
                        </InputGroup>
                      </Form>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <Card className="col-lg-10 mx-auto  mt-3">
                {params.count !== 0 ? (
                  <CardBody className="pb-0">
                    <h4 className="card-title">COMPRAS</h4>
                    <div className="table-responsive">
                      <Table
                        className="table  mb-3 text-center"
                        hover
                        responsive
                      >
                        <thead className="table-dark">
                          <tr>
                            <th>#</th>
                            <th>CLIENTE</th>
                            <th>PROVEEDOR </th>
                            <th>VALOR A PAGAR </th>
                            <th>ESTADO DE COMPRA </th>
                            <th>COMPROBANTE </th>
                           
                          </tr>
                        </thead>
                        <tbody>
                          {params.results &&
                            params.results.map((compras, idx) => {
                              const cliente = contact.find(
                                (item) => item.id === compras.Cliente
                              );
                              const proveedor = contact.find(
                                (item) => item.id === compras.Proveedor
                              );

                              console.log(cliente);
                              return (
                                <tr key={idx}>
                                  <th scope="row">{idx + 1}</th>

                                  <td>
                                    {cliente
                                      ? cliente.razon_social !== ""
                                        ? cliente.razon_social
                                        : cliente.get_full_name
                                      : null}
                                  </td>
                                  <td>
                                    {proveedor
                                      ? proveedor.razon_social !== ""
                                        ? proveedor.razon_social
                                        : proveedor.get_full_name
                                      : null}
                                  </td>
                                  <td>{compras.valor_pagar}</td>

                                  {
                                    compras.estado_compra ==='en_proceso' ?(
                                      <td>EN PROCESO</td>
                                    ):(

                                      <td>{compras.estado_compra.toUpperCase()}</td>
                                    )
                                  }
                                  
                                  <td>

{compras.estado_compra !== "pagado" ? (
    <button
      className="btn-info "
      style={{
        marginLeft: "5px",
        cursor: "pointer",
        color: "white",
        // borderColor:'#158cba',
        // background:'#158cba'


      }}
      onClick={() =>
        handleEditCompras(compras)
      }
    >Agregar Comprobante</button>
  ) : 
  <span
                                      className=" fas fa-eye fa-lg "
                                      style={{
                                        cursor: "pointer",
                                        color: "#045e94",
                                      }}
                                      onClick={() => handleVerCompras(compras)}
                                    ></span>
  }
</td>

                                 
                               
                                </tr>
                              );
                            })}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={10}
                      baseUrl="tramite/entidad/"
                      // filterFunction={entidadInternaListChange}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">NO SE ENCONTRARON RESULTADOS</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, compras } = state.Compras;
  return { error, loading, compras };
};

export default withRouter(connect(mapStateToProps)(Compras));
